import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import React__default from 'react';
import { SolutionsChartDashboardItem, SolutionsOpenEndedItem } from '@sm/question-ui/aggregate-response-customizable-solutions';
import { d as declareVisualization, p as providerFactory } from './utils-5126869e.js';
import { isOneDimensionalAggregateResponse, isTwoDimensionalAggregateResponse } from '@sm/question-definitions';
export { S as SingleQuestionController } from './controllers-8c913634.js';
import './vendor-8000eab9.js';
import '@sm/question-ui/helpers';
var sortCellToLabelOrder = function sortCellToLabelOrder(labelsArray, dataToSort) {
  return labelsArray.map(function (label) {
    return dataToSort.find(function (data) {
      return data.rowItem.id === label;
    });
  });
};
var getDataByColumn = function getDataByColumn(aggregateResponse, columnID, isPercentage) {
  var filtered = aggregateResponse.data.filter(function (item) {
    return item.columnItem.id === columnID;
  });
  var sorted = aggregateResponse.rowHeader.items.map(function (_ref) {
    var id = _ref.id;
    return filtered.find(function (item) {
      return item.rowItem.id === id;
    });
  });
  return sorted.map(function (responseCell) {
    if (isPercentage) {
      return responseCell.percentage;
    }
    return responseCell.total;
  });
};
// TODO: Update 2D transformations as part of MOD-7279
// Ideally merge all of this file with a common transformation
// that is used by all capabilities
var mapToTwoDimensionalChartData = function mapToTwoDimensionalChartData(data, isPercentageData) {
  return data.columnHeader.items.map(function (column) {
    return {
      name: column.label,
      data: getDataByColumn(data, column.id, isPercentageData),
      value: 0,
      numberOfResponses: 0
    };
  });
};
var transformOneDimensionalData = function transformOneDimensionalData(sortedData, customization, isPercentageData) {
  switch (customization.chartType) {
    case 'hbar':
    case 'vbar':
      {
        return sortedData.map(function (dataItem) {
          var _a;
          return isPercentageData ? (_a = dataItem.percentage) !== null && _a !== void 0 ? _a : 0 : dataItem.total;
        });
      }
    case 'donut':
    case 'pie':
      {
        return sortedData.map(function (item) {
          var _a;
          return {
            name: item.rowItem.label,
            value: (_a = item.percentage) !== null && _a !== void 0 ? _a : 0,
            numberOfResponses: item.total
          };
        });
      }
    case 'line':
    case 'area':
      {
        return [{
          name: '',
          data: sortedData.map(function (dataItem) {
            var _a;
            return isPercentageData ? (_a = dataItem.percentage) !== null && _a !== void 0 ? _a : 0 : dataItem.total;
          })
        }];
      }
    case 'stacked_hbar':
    case 'stacked_vbar':
      {
        return sortedData.map(function (dataItem) {
          var _a;
          return {
            name: dataItem.rowItem.label,
            data: [isPercentageData ? (_a = dataItem.percentage) !== null && _a !== void 0 ? _a : 0 : dataItem.total]
          };
        });
      }
    default:
      {
        return null;
      }
  }
};
var transformToChartData = function transformToChartData(data, customization) {
  var _a, _b;
  if (!data.data || data.data.length === 0) {
    return null; // No matching responses
  }

  var rowLabelIDs = (_b = (_a = data === null || data === void 0 ? void 0 : data.rowHeader) === null || _a === void 0 ? void 0 : _a.items.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  })) !== null && _b !== void 0 ? _b : [];
  var isPercentageData = customization.axisScale === 'Percentage';
  var chartTypesWith2DSupport = ['hbar', 'vbar', 'line', 'area', 'stacked_hbar', 'stacked_vbar'];
  if (isOneDimensionalAggregateResponse(data)) {
    var sortedData = sortCellToLabelOrder(rowLabelIDs, data.data);
    return transformOneDimensionalData(sortedData, customization, isPercentageData);
  }
  if (chartTypesWith2DSupport.includes(customization.chartType) && isTwoDimensionalAggregateResponse(data)) {
    return mapToTwoDimensionalChartData(data, isPercentageData);
  }
  // eslint-disable-next-line no-console
  console.error('Incorrect chart data or customization');
  return null;
};
function ChartVisualization(_ref3) {
  var question = _ref3.question,
    _ref3$displayOptions = _ref3.displayOptions,
    displayOptions = _ref3$displayOptions === void 0 ? {} : _ref3$displayOptions;
  var _a, _b;
  var title = question.title,
    questionNumber = question.questionNumber,
    aggregateResponse = question.aggregateResponse;
  if (!aggregateResponse || !(displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.customization)) {
    // eslint-disable-next-line no-console
    console.error('Aggregate response or customization is null or undefined');
    return null;
  }
  var customization = displayOptions.customization;
  var otherAnswers = aggregateResponse.otherAnswers;
  var data = transformToChartData(aggregateResponse, customization);
  var chartCustomization = _objectSpread(_objectSpread({}, customization), {}, {
    labels: (_b = (_a = aggregateResponse === null || aggregateResponse === void 0 ? void 0 : aggregateResponse.rowHeader) === null || _a === void 0 ? void 0 : _a.items.map(function (item) {
      return item.label;
    })) !== null && _b !== void 0 ? _b : []
  });
  var dashboardItems = {
    title: title,
    questionNumber: questionNumber,
    data: data !== null && data !== void 0 ? data : [],
    customization: chartCustomization,
    otherAnswers: otherAnswers
  };
  return React__default.createElement(SolutionsChartDashboardItem, _objectSpread({}, dashboardItems));
}
var ChartVisualization$1 = declareVisualization(['check_box', 'image_choice', 'multiple_choice', 'matrix', 'dropdown', 'ranking'], ['aggregate-response-customizable-solutions'], ChartVisualization);
function OpenEndedVisualization(_ref4) {
  var question = _ref4.question,
    _ref4$displayOptions = _ref4.displayOptions,
    displayOptions = _ref4$displayOptions === void 0 ? {} : _ref4$displayOptions;
  var responseData = question.responseData,
    title = question.title,
    questionNumber = question.questionNumber;
  var height = displayOptions.height,
    width = displayOptions.width;
  return React__default.createElement(SolutionsOpenEndedItem, _objectSpread(_objectSpread({}, {
    height: height,
    width: width,
    title: title,
    questionNumber: questionNumber
  }), {}, {
    words: responseData || [],
    onSearch: function onSearch() {
      return undefined;
    }
  }));
}
var openEndedVisualization = declareVisualization(['single_textbox', 'comment_box'], ['aggregate-response-customizable-solutions'], OpenEndedVisualization);
var visualizationList = [ChartVisualization$1, openEndedVisualization];
var ProviderHelper = providerFactory(visualizationList);
function AggregateResponseCapabilityProvider(_ref5) {
  var upstreamActions = _ref5.upstreamActions,
    settings = _ref5.settings,
    children = _ref5.children,
    renderProps = _ref5.renderProps;
  return React__default.createElement(ProviderHelper, {
    value: {
      capability: 'aggregate-response-customizable-solutions',
      upstreamActions: upstreamActions,
      renderProps: renderProps,
      settings: settings
    }
  }, children);
}
export { AggregateResponseCapabilityProvider as AggregateResponseCustomizableSolutionsProvider, visualizationList as AggregateResponseCustomizableSolutionsVisualizationList };